<script>
  /* External */
  import marked from "marked";

  /* Svelte */
  import { beforeUpdate } from "svelte";

  /* Stores */
  import storeGlobal from "../../stores/storeGlobal";

  /* Constants */
  import URL from "../../constants/url";

  beforeUpdate( () => {
    if (notes != undefined ){
      markdown = marked(notes);
    }

    singlePigments = pigments.split(' – ');
  })

  /* Variables */
  let {
    name,
    line,
    producer,
    photoBefore,
    photoAfter,
    pigments,
    vegan,
    medium,
    lightfastness,
    transparency,
    granulation,
    staining,
    binder,
    notes
  } = $storeGlobal.detailColor;

  /* Staining */
  if ( staining === "non") {
    staining = "not staining";
  } else if ( staining === "semi"){
    staining = "semi staining";
  } else if (staining === "unknown"){
    staining = "not available";
  } else {
    staining = "staining";
  }

  /* Granulating */
  if ( granulation === "non") {
    granulation = "not granulating";
  } else if ( granulation === "semi"){
    granulation = "semi granulating";
  } else if (granulation === "unknown"){
    granulation = "not available";
  } else {
    granulation = "granulating";
  }


  /* transparent */
  if ( transparency === "opaque") {
    transparency = "opaque";
  } else if ( transparency === "semi"){
    transparency = "semi transparent";
  } else if (transparency === "unknown"){
    transparency = "not available";
  } else {
    transparency = "transparent";
  }


  let singlePigments;
  let markdown;

  if(photoAfter === null){
    photoAfter = [];
    photoAfter.url= "/uploads/b9f4a2ac78114ca386a3e80cb4745f51.jpg";
  }

  const toggleModal = (color) => {
    storeGlobal.updateItem('showDetails', false);
    storeGlobal.updateItem('detailColor', '');
  }

  const searchSimilarPigment = (pig) => {
    storeGlobal.updateItem('showDetails', false);
    storeGlobal.updateItem('searchTerm', pig);
    storeGlobal.updateItem('searchPigment', true);
  }
</script>

<style>
  @media (min-width: 780px) {
    .content::after{
      position: absolute;
      content: '';
      bottom: -140px;
      height: 20px;
      width: 1px;
    }
  }
</style>


<!-- Markdown -->
<div class="fixed top-0 left-0 bg-smoke_bg w-full h-full z-40 overflow-y-scroll"
     on:click|self="{ toggleModal }">

  <div class="content
              absolute
              top-0
              left-auto
              w-full
              ml-0
              bg-white
              dark:bg-slate
              sm:h-auto
              sm:bottom-auto
              sm:top-80
              sm:left-1/2
              sm:w-620
              sm:-ml-310
              sm:rounded-lg">

    <!-- Header -->
    <div class="p-6">

      <!-- Cardtitle -->
      <h1 class="flex items-center text-xl xs:text-2xl sm:text-3xl dark:text-smoke_xd"> 
        { name } 
        {#if vegan}
          <svg viewBox="0 0 24 18.172" xmlns="http://www.w3.org/2000/svg" class="fill-current mt-1 ml-2 text-green w-5 h-4">
            <path d="M23.972 4.978a.692.692 0 00-.258-.754c-2.33-1.69-4.683-2.889-6.991-3.563-2.94-.858-5.853-.881-8.658-.068-4.376 1.272-6.906 5.868-5.639 10.245.123.422.277.83.46 1.22l-2.8 5.088a.692.692 0 001.212.668l2.408-4.376a8.251 8.251 0 002.677 2.34 8.207 8.207 0 006.288.699c3.31-.96 4.488-4.146 5.251-5.877 1.165-2.644 2.172-4.926 5.427-5.125a.692.692 0 00.623-.497zM8.451 1.922c3.31-.96 6.749-.637 10.265.954-1.833-.091-3.796.167-5.725.783a17.47 17.47 0 00-9.2 6.906c-1.131-3.667.969-7.57 4.66-8.643zm8.205 8.12c-.997 2.263-1.94 4.4-4.37 5.106a6.832 6.832 0 01-5.235-.582 6.851 6.851 0 01-2.585-2.483 16.105 16.105 0 018.947-7.105c1.729-.553 3.534-.8 5.222-.718.822.04 1.61.159 2.341.35a5.911 5.911 0 00-2.134 1.568c-.968 1.102-1.587 2.506-2.186 3.863z"/></svg>
        {/if}
      </h1>

      <h2 class="mt-1 text-sm sm:text-base">
        <p class="text-blue_d dark:text-blue inline-block">
          { line }
        </p>

        <p class="inline-block text-blue_d dark:text-blue">
          <span class="text-silver dark:text-snow_xd">by</span>
          { producer }
        </p>
      </h2>

      <button class="absolute top-0 right-0 m-8 text-slate" on:click="{ toggleModal }">
        <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" class="fill-current w-5 h-4 text-slate dark:text-smoke_xd">
          <path d="M8.884 8l6.933-6.933a.625.625 0 10-.884-.884L8 7.116
                   1.067.183a.625.625 0 10-.884.884L7.116 8 .183 14.933a.625.625
                   0 10.884.884L8 8.884l6.933 6.933a.623.623 0 00.884 0 .625.625
                   0 000-.884z"/>
        </svg>
      </button>
    </div>

    <!-- ImageBox -->
    <div class="flex" >

      <div class="w-full">
        <img class="w-full" alt="" src="{URL}/{photoBefore.url}"/>
      </div>

      <div class="w-full relative">
        <div class="absolute top-0 right-0">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" class="w-10 h-10 fill-current bg-blackd text-snow m-4 rounded-full p-1">
            <path d="M24.906 3.969c-.043.008-.086.02-.125.031A1.002 1.002 0 0024 5v6c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879V5a1 1 0 00-1.094-1.031zm-14.25 5.875a.994.994 0 00-.781.703c-.105.367.004.758.281 1.015l4.25 4.25c.242.297.63.434 1.004.348.371-.086.664-.379.75-.75a1.004 1.004 0 00-.348-1.004l-4.25-4.25a1.004 1.004 0 00-.812-.312h-.094zm28.375 0a1.005 1.005 0 00-.593.312l-4.25 4.25a1.004 1.004 0 00-.348 1.004c.086.371.379.664.75.75.375.086.762-.05 1.004-.348l4.25-4.25a1 1 0 00-.813-1.719zM25 15c-5.516 0-10 4.484-10 10s4.484 10 10 10 10-4.484 10-10-4.484-10-10-10zM4.719 24c-.551.078-.938.59-.86 1.14.079.551.59.938 1.141.86h6c.36.004.695-.184.879-.496a1.01 1.01 0 000-1.008c-.184-.312-.52-.5-.879-.496H4.719zm34 0c-.551.078-.938.59-.86 1.14.078.551.59.938 1.141.86h6c.36.004.695-.184.879-.496a1.01 1.01 0 000-1.008c-.184-.312-.52-.5-.879-.496H38.719zM15 33.875a1.005 1.005 0 00-.594.313l-4.25 4.25a1.004 1.004 0 00-.347 1.003c.086.371.379.664.75.75.375.086.761-.05 1.004-.347l4.25-4.25a1.002 1.002 0 00-.719-1.719H15zm19.688 0a.994.994 0 00-.782.703c-.105.367.004.758.282 1.016l4.25 4.25c.242.297.628.433 1.003.347.371-.086.664-.379.75-.75a1.004 1.004 0 00-.347-1.004l-4.25-4.25a1 1 0 00-.719-.312h-.187zm-9.782 4.094c-.043.008-.086.02-.125.031A1.002 1.002 0 0024 39v6c-.004.36.184.695.496.879.313.18.695.18 1.008 0 .312-.184.5-.52.496-.879v-6a1 1 0 00-1.094-1.031z"/>
          </svg>
        </div>
        <img class="w-full" alt="" src="{URL}/{photoAfter.url}"/>
      </div>
    </div>

    <!-- Pigments -->
    <div class="flex items-center p-4 text-sm border-b border-smoke dark:border-steel">
      <div class="py-2">
        {#each singlePigments as pigment}
          <button class="inline-block cursor-pointer uppercase bg-smoke text-slate px-2 py-1 rounded-lg text-sm mx-2 dark:bg-smoke_xd hover:bg-teal" on:click="{ searchSimilarPigment(pigment) }">
              { pigment }
          </button>
        {/each}
      </div>
    </div>


    <!-- Content -->
    <div class="py-6 px-8">
      <ul>
        <li class="flex justify-between py-2">
          <span class="text-silver"> Medium: </span>
          <span> { medium } </span>
        </li>

        <hr class="dark:border-steel"/>

        <li class="flex justify-between py-2">
          <span class="text-silver"> Lightfastness </span>
          <span> { lightfastness } </span>
        </li>

        <hr class="dark:border-steel"/>

        <li class="flex justify-between py-2">
          <span class="text-silver"> Transparency </span>
          <span> { transparency } </span>
        </li>

        <hr class="dark:border-steel"/>

        <li class="flex justify-between py-2">
          <span class="text-silver"> Granulation </span>
          <span> { granulation } </span>
        </li>

        <hr class="dark:border-steel"/>

        <li class="flex justify-between py-2">
          <span class="text-silver"> Staining </span>
          <span> { staining } </span>
        </li>

        <hr class="dark:border-steel"/>

        <li class="flex justify-between py-2">
          <span class="text-silver"> Binder </span>
          <span> { binder } </span>
        </li>
      </ul>

    </div>

    {#if markdown !== undefined}
      <!-- Notes -->
      <div class="p-6 bg-snow_xd dark:bg-steel">
        <span class="text-sm py-1 px-2 rounded-lg bg-slate text-snow"> Notes: </span>
        <p class="p-4 pt-4">
          { @html markdown }
        </p>
      </div>
    {/if}


    <!-- footer -->
    <div class="border-t border-smoke text-xs text-silver text-center py-3 dark:border-steel">
      Information is gathered from producers websites etc.
    </div>

  </div>
</div>
